import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";
import MobileListUi from "../../../helpers/MobileListUi/MobileListUi";
import NewsModal from "../../../helpers/NewsModal/NewsModal";
import MenuUi from "../../../helpers/MenuUi/MenuUi";
import { decodeJWT } from "../../../utils";

import { TbClockCancel } from "react-icons/tb";
import { TbLoader } from "react-icons/tb";
import { AiFillNotification } from "react-icons/ai";

import { pricePublicContext } from "../../../context/PublicContext/PricePublicContext/PricePublicContext";

const MobilePriceView = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const timerStatus = useSelector((state) => state.timerStatus);

  const token = localStorage.getItem("token");
  const roleName = decodeJWT(token)?.usertype;

  const {
    setIs_orderi,
    description,
    setDescription,
    setCustomeruser,
    product_name,
    setProduct_name,
    resultModal,
    setResultModal,
    orderModal,
    setOrderModal,
    data,
    setData,
    getItemsList,
    type,
    setType,
    stateWeight,
    setStateWeight,
    setBos,
    transactionId,
    statePrice,
    setStatePrice,
    stateTotal,
    setStateTotal,
    setCounter,
    handleGetItemsList,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    loading,
    setLoading,
    openModal,
    setOpenModal,
    isTimerOn,
    setIsTimerOn,
    handleStartTimer,
    buyTolerance,
    setBuyTolerance,
    sellTolerance,
    setSellTolerance,
    handleChangeBuyPrice,
    handleChangeSellPrice,
    handleUpdateProduct,
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
  } = useContext(pricePublicContext);

  //* Get Data Start
  const handleInitial = async () => {
    setCounter((prevCounter) => prevCounter + 1);
    await handleGetItemsList();
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleInitial();
      setLoading(false);
    };
    fetchData();

    const interval = setInterval(handleInitial, 1000);
    return () => clearInterval(interval);
  }, []);
  //* Get Data End

  // ✅ مرتب‌سازی و سپس فیلتر کردن
  // ابتدا لیست را بر اساس priority_num سورت می‌کنیم (صعودی)
  const sortedItems = [...getItemsList].sort(
    (a, b) => a.priority_num - b.priority_num,
  );

  // سپس بر اساس tag فیلتر می‌کنیم
  const goldItems = sortedItems.filter((item) => item.tag === "T");
  const coinItems = sortedItems.filter((item) => item.tag === "S");

  const tableTitle = [
    { id: 1, title: "#" },
    { id: 2, title: "نام محصول" },
    { id: 3, title: "خرید شما(تومان)" },
    { id: 4, title: "فروش شما(تومان)" },
    { id: 5, title: "آخرین آپدیت" },
  ];

  if (loading) {
    return (
      <span className="w-full h-full absolute space-y-5 left-0 right-0 top-[2.5rem] text-black text-xl flex flex-col justify-center items-center">
        <TbLoader size={60} className="animate-spin" />
        <p>لطفا صبر کنید</p>
      </span>
    );
  }

  return (
    <>
      <SiteTitle title="لیست قیمت ها" />
      {isEmpty(getItemsList) ? (
        <>
          <MenuUi className={"top-3"} />
          <span className="w-full h-full absolute space-y-5 left-0 right-0 top-[2.5rem] text-black text-xl flex flex-col justify-center items-center">
            <TbClockCancel size={60} />
            <p>سامانه بسته می باشد</p>
          </span>
        </>
      ) : (
        <>
          <div className="mt-2 mb-16 space-y-6 w-full relative flex flex-col justify-center overflow-auto z-20">
            {/* News */}
            <div className="w-full">
              <span className="flex justify-end mx-3 z-40">
                <ColorChangingIcon
                  Icon={AiFillNotification}
                  size={30}
                  firstColor="#ffe700"
                  secondColor="#ffffff"
                  onClick={() => setOpenModal(!openModal)}
                />
              </span>
              {openModal && <NewsModal openModal={openModal} />}
            </div>

            {/* ✅ بخش طلاها (T) */}
            {goldItems.length > 0 && (
              <div className="bg-amber-50/30 rounded-xl p-3 border border-amber-200 shadow-sm">
                <h2 className="text-center text-base sm:text-lg font-bold text-amber-800 mb-3 py-1 rounded bg-amber-100">
                  طلاها
                </h2>
                <table className="w-full">
                  <thead className="text-xs sm:text-sm font-medium text-amber-900 bg-amber-100 rounded-t-lg">
                    <tr>
                      {tableTitle.map((_item) => (
                        <th key={_item.id} className="py-2 px-2 text-center">
                          {_item.title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="text-sm divide-y divide-amber-200">
                    {goldItems.map((_item, index) => (
                      <MobileListUi
                        key={_item.id}
                        roleName={roleName}
                        timerStatus={timerStatus}
                        index={index}
                        _item={_item}
                        data={data}
                        setData={setData}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        orderModal={orderModal}
                        setOrderModal={setOrderModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        userInfo={userInfo}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        isTimerOn={isTimerOn}
                        setIsTimerOn={setIsTimerOn}
                        handleStartTimer={handleStartTimer}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ✅ بخش مسکوکات (S) */}
            {coinItems.length > 0 && (
              <div className="bg-blue-50/30 rounded-xl p-3 border border-blue-200 shadow-sm">
                <h2 className="text-center text-base sm:text-lg font-bold text-blue-800 mb-3 py-1 rounded bg-blue-100">
                  مسکوکات
                </h2>
                <table className="w-full">
                  <thead className="text-xs sm:text-sm font-medium text-blue-900 bg-blue-100 rounded-t-lg">
                    <tr>
                      {tableTitle.map((_item) => (
                        <th key={_item.id} className="py-2 px-2 text-center">
                          {_item.title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="text-sm divide-y divide-blue-200">
                    {coinItems.map((_item, index) => (
                      <MobileListUi
                        key={_item.id}
                        roleName={roleName}
                        timerStatus={timerStatus}
                        index={index}
                        _item={_item}
                        data={data}
                        setData={setData}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        orderModal={orderModal}
                        setOrderModal={setOrderModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        userInfo={userInfo}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        isTimerOn={isTimerOn}
                        setIsTimerOn={setIsTimerOn}
                        handleStartTimer={handleStartTimer}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default MobilePriceView;
